import { render, staticRenderFns } from "./CreateJobTitles.vue?vue&type=template&id=c4b81356&scoped=true"
import script from "./CreateJobTitles.vue?vue&type=script&lang=ts"
export * from "./CreateJobTitles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b81356",
  null
  
)

export default component.exports